export default __webpack_public_path__ + "static/media/menu-header-bg.f2f727a0.png";